import $ from 'jquery';
import { spring } from "motion"
import Swiper from 'swiper/bundle';
import 'swiper/css';

window.$ = $;
window.Swiper = Swiper;

$('header button').on('click', function(){
    $('.nav-container').toggleClass('active');
    $('.menu-button').toggleClass('active');
})